(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // 1. Find the main product gallery container element
  const mediaGallery = document.querySelector('.product__media-gallery, [data-device="desktop"] .slider, .product-media-container');
  if (!mediaGallery) return;

  // 2. Inject the exact styles to render the white circular floating arrows
  if (!document.getElementById('gs-arrow-styles')) {
    const style = document.createElement('style');
    style.id = 'gs-arrow-styles';
    style.innerHTML = `
      .product__media-gallery, .product-media-container {
        position: relative !important;
      }
      .gs-circle-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 44px;
        height: 44px;
        background: #ffffff !important;
        border-radius: 50% !important;
        border: none !important;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
        cursor: pointer !important;
        z-index: 1000 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        transition: transform 0.2s ease, opacity 0.2s ease !important;
        opacity: 0;
        pointer-events: auto !important;
      }
      /* Make the circular buttons slide into view gracefully on image hover */
      .product__media-gallery:hover .gs-circle-arrow,
      .product-media-container:hover .gs-circle-arrow {
        opacity: 1;
      }
      .gs-circle-arrow:hover {
        transform: translateY(-50%) scale(1.08) !important;
      }
      .gs-circle-arrow.gs-prev { left: 20px; }
      .gs-circle-arrow.gs-next { right: 20px; }
      .gs-circle-arrow svg {
        width: 14px;
        height: 14px;
        fill: none;
        stroke: #000000;
        stroke-width: 3;
        stroke-linecap: round;
        stroke-linejoin: round;
      }
    `;
    document.head.appendChild(style);
  }

  // 3. Construct the clean chevron elements matching your reference image
  const prevButton = document.createElement('button');
  prevButton.className = 'gs-circle-arrow gs-prev';
  prevButton.setAttribute('type', 'button');
  prevButton.innerHTML = `<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>`;

  const nextButton = document.createElement('button');
  nextButton.className = 'gs-circle-arrow gs-next';
  nextButton.setAttribute('type', 'button');
  nextButton.innerHTML = `<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>`;

  mediaGallery.appendChild(prevButton);
  mediaGallery.appendChild(nextButton);

  // 4. Map the clicks directly into your underlying theme slide components
  const getThemeButtons = () => {
    return {
      next: mediaGallery.querySelector('button[name="next"], .slider-button--next, .swiper-button-next, .slideshow-control--next'),
      prev: mediaGallery.querySelector('button[name="previous"], .slider-button--prev, .swiper-button-prev, .slideshow-control--prev')
    };
  };

  const sliderContainer = mediaGallery.querySelector('.slider, ul, [role="list"]') || mediaGallery;

  prevButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Kills the theme zoom overlay popup
    const buttons = getThemeButtons();
    if (buttons.prev) {
      buttons.prev.click();
    } else {
      sliderContainer.scrollBy({ left: -sliderContainer.clientWidth, behavior: 'smooth' });
    }
  });

  nextButton.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Kills the theme zoom overlay popup
    const buttons = getThemeButtons();
    if (buttons.next) {
      buttons.next.click();
    } else {
      sliderContainer.scrollBy({ left: sliderContainer.clientWidth, behavior: 'smooth' });
    }
  });
});
document.dispatchEvent(new Event('DOMContentLoaded'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Broad selector to find your theme's image wrapper
  const mediaGallery = document.querySelector('.product__media-gallery, [data-device="desktop"] .slider, .product-media-container, .product-gallery, .product__images');
  if (!mediaGallery) return;

  const leftZone = document.createElement('div');
  const rightZone = document.createElement('div');
  
  leftZone.className = 'gravastar-click-zone left-zone';
  rightZone.className = 'gravastar-click-zone right-zone';
  
  const zoneStyles = 'position: absolute; top: 0; bottom: 0; width: 50%; z-index: 10; cursor: pointer;';
  leftZone.style.cssText = zoneStyles + 'left: 0;';
  rightZone.style.cssText = zoneStyles + 'right: 0;';
  
  mediaGallery.style.position = 'relative';
  mediaGallery.appendChild(leftZone);
  mediaGallery.appendChild(rightZone);

  // Targets standard theme slider arrows
  const nextBtn = document.querySelector('button[name="next"], .slider-button--next, .swiper-button-next, .product-gallery__nav--next');
  const prevBtn = document.querySelector('button[name="previous"], .slider-button--prev, .swiper-button-prev, .product-gallery__nav--prev');

  leftZone.addEventListener('click', function (e) {
    e.stopPropagation();
    if (prevBtn) prevBtn.click();
  });

  rightZone.addEventListener('click', function (e) {
    e.stopPropagation();
    if (nextBtn) nextBtn.click();
  });
});

  } catch(e) { console.error(e); }
})();
})();
